import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask"

export default class extends Controller {
  static targets = ["toggle", "input"]

  connect() {
    this.initializeMask()
  }

  initializeMask() {
    this.applyMask(this.toggleTarget.checked)
  }

  toggleChange() {
    const isPounds = this.toggleTarget.checked
    let rawValue = this.getRawValue()

    if (rawValue === '' || rawValue === '-') rawValue = '0'

    // Remove the current mask BEFORE changing the value
    if (this.inputTarget.inputmask) {
      this.inputTarget.inputmask.remove()
    }

    if (isPounds) {
      // Pence → Pounds
      const pence = parseInt(rawValue, 10)
      if (!isNaN(pence)) {
        this.inputTarget.value = (pence / 100).toFixed(2)
      }
    } else {
      // Pounds → Pence
      const pounds = parseFloat(rawValue)
      if (!isNaN(pounds)) {
        this.inputTarget.value = Math.round(pounds * 100)
      }
    }

    this.applyMask(isPounds)
  }

  applyMask(isPounds) {
    if (isPounds) {
      Inputmask({
        alias: 'currency',
        prefix: '£ ',
        groupSeparator: ',',
        autoGroup: true,
        digits: 2,
        digitsOptional: false,
        placeholder: '0.00',
        rightAlign: false,
        unmaskAsNumber: false
      }).mask(this.inputTarget)
    } else {
      Inputmask({
        alias: 'numeric',
        groupSeparator: ',',
        autoGroup: true,
        digits: 0,
        digitsOptional: true,
        placeholder: '0',
        rightAlign: false,
        integerDigits: 10
      }).mask(this.inputTarget)
    }
  }

  getRawValue() {
    if (this.inputTarget.inputmask) {
      return this.inputTarget.inputmask.unmaskedvalue()
    } else {
      return this.inputTarget.value.replace(/[^\d.-]/g, '')
    }
  }
}
